import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    root: {
      padding: '0px 15px',
      display: 'flex',
      alignItems: 'center',
      minHeight: 40,
    },
  });

export type Styles = WithStyles<typeof styles>;
